<template>
    <div class="container-fluid">
        <div class="row py-3 ">
            <div class="designRowOrga w-100">
                <div class="h3Organization w-50">
                    <img src="../../../assets/images/title-icon.png" alt="">
                    <h3>Organizations</h3>
                </div>
                <div class="right-header-container">
                    <div class="twoInputs">
                        <div class="btnInsideInput w-100">
                            <button @click="searchBackEndHandler" ref="buttonSearch" class="search-btn">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                    placeholder="Search" autocomplete="off"
                                    @input="searchHandler" maxlength="50">
                            
                        </div>
                    </div>
                    <div class="fullInputs mb-4">
                        <div class="oneInput w-100">
                            <select id="filter_dates" class="form-select" v-model="sort" @change="getOrganizations">
                                <option selected disabled value="false">Sort by Date</option>
                                <option value="asc">Oldest</option>
                                <option value="desc">Latest</option>
                            </select>
                        </div>
                    </div>
                    
                    <router-link class="text-decoration-none btn-container"
                                v-if="permissions.includes('create organization') && organizations.length > 0"
                                to="/create-organizations">
                        <span>Create</span>
                    </router-link>
                </div>
            </div>

            <div class="tabcontent tabcontent-bark-mode">
                
                <div class="table-container" v-if="organizations.length > 0">

                    <TableComponent class="main-table" :thead="thead" :tbody="organizations" @sort="SortOrganization" :keys="keys"
                                    model="organizations" name="organization"
                                    updateUrl="/edit-organizations" @update="updateOrganization"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getOrganizations" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>

                <div v-else class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
                    <div class="no-data-header-container">
                        <h3 v-if="!isSearch" class="no-data-header">You Don't Have Any Organizations Yet</h3>
                        <h3 v-else>No Data</h3>
                    </div>
                    <router-link class="text-decoration-none btn-container  btn-container-no-data"
                                 v-if="permissions.includes('create organization') && organizations.length === 0 && !isSearch"
                                 to="/create-organizations">
                        <span class="create-btn-text">Create Organization</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import TableComponent from "../../components/TableComponent";
    import organization from "../../../api-services/organization";
    import LaravelVuePagination from 'laravel-vue-pagination';

    export default {
        name: 'organization-page',
        mounted() {
            this.permissions = this.$store.state.auth.permissions;
            this.getOrganizations();
            this.$store.dispatch('activeTap', 'organizations');
        },
        data() {
            return {
                thead: ['Organization Name', 'Admin Email'],
                keys: ['name', 'user_id'],
                permissions: [],
                organizations: [],
                filteredArray: [],
                originalOrganizations: [],
                laravelData: {},
                error: null,
                search: null,
                isSearch: false,
                sort: false,
                state: false
            }
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        methods: {
            CreateOrganization() {
                this.$router.push({name: 'create-organization'});
            },
            getOrganizations: async function (page = 1) {

                try {
                    const response = await organization.index(this.search, this.sort === false ? this.sort = 'desc' : this.sort, page);
                    this.organizations = response.data.data;
                    this.laravelData = response.data;
                    this.originalOrganizations = response.data.data;

                } catch (e) {
                    console.log(e);
                    this.error = e;
                }

            },
            updateOrganization(e) {
                let filteredData = this.organizations.filter(function (data) {
                    return data.id != e;
                });
                this.organizations = filteredData;
                this.getOrganizations();

            },
            searchHandler(e) {
                this.isSearch = true;
            },
            async searchBackEndHandler() {
                await this.getOrganizations();
            },
            SortOrganization() {
                let status = !this.state;
                this.originalOrganizations.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.state = status;
            }
        }
    }
</script>

<style scoped>
    .no-data-header{
        font-size: 18px;
    }
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #DDD !important;
        opacity: 0.5 !important; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #DDD !important;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #DDD !important;
    }
    .create-btn-text{
        font-size: 17px;
    }
    .tabcontent{
        height:73vh;
        padding-top: 0 !important;
        overflow-y: auto;
    }
    .h3Organization{
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }
    .h3Organization img{
        margin-bottom:0;
        padding-right: 10px;
    }
    .h3Organization h3{
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom: 0;
        font-size: calc(1.1rem+0.6vw);
    }
    .right-header-container{
        display: flex;
        flex-direction: row;
        justify-content:space-between;
        width:45%;
        height: 35px;
    }
    .right-header-container .btn-container{
        font-size: 16px;
        width: 25%;
        font-weight: normal;
    }
    .twoInputs{
        width:45%;
    }
    .search-btn{
        width: 10%;
        border-radius: 6px 0 0 6px;
        background-color:#707070;
        align-items: center;
        padding-bottom: 3px;
    }
    .btnInsideInput{
        border-radius: 6px;
        background-color: #707070;
    }
    .btnInsideInput input{
        border-radius: 6px;
        background-color: #707070;
        padding-left: 0;
        padding-top: 5px;
        padding-bottom: 0;
        
    }
    .form-control {
        color: white !important;
        display: flex;
        justify-content: left;
        width:90% !important;
        padding-left: 10px !important;
    }
    .designRowOrga{
        padding-left:40px !important;
        padding-right: 40px;
        height: 50px;
        align-items: center;
        margin-bottom: 2%;
    }
    .paginationLink{
        font-size:11px;
        font-weight: bold;
        width:99%;
    }
    .fullInputs{
        width:150px;
        height: 100%;
    }
    .oneInput{
        height: 100%;
    }
    #filter_dates{
        width:100% !important;
        border: none;
        padding:0;
        padding-left: 10px;
        height: 100% !important;
    }
    #free_search::placeholder{
        opacity: 1 !important;
        color: white !important;
        /* font-size: 19px; */
    }
    @media(max-width:1280px){
        .h3Organization{
            width: 40% !important;
        }
        .h3Organization img{
            width: 5vh !important;
        }
        .right-header-container{
            width:60%;
            /* margin-top: 10px; */
        }
        .twoInputs{
            margin-bottom:0 !important;
        }
        .table-container :deep(thead :first-child){
        width:40% !important;
        }
        .tabcontent{
            padding-top: 0 !important;
            overflow-y: scroll;
        }
    }
    @media(max-height:767px){
        .tabcontent{
            height: 69vh;
        }
    }
</style>